module.exports = __webpack_public_path__ + "img/DOB.3412cfb0.svg";